import { Blockchain } from './Blockchain/Blockchain'
import { Currency } from './Currency/Currency'
import { Nickname } from './Nickname/Nickname'
import { Status } from './Status/Status'

export const AddressBookFilter = {
  Nickname,
  Blockchain,
  Currency,
  Status,
}
